import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../../../../../Context/UserContext";
import Button from "../../../../../Reusable/Button";
import toast from "react-hot-toast";
import { BaseURL } from "../../../../../Reusable/BaseURL";
import IndentCreatePageForm from "../../../../../purchaseFormPages/IndentCreatePageForm";
import { SeveritySelect } from "../../../../../Reusable/SeveritySelect";
import MyTextarea from "../../../../../Reusable/MyTextarea";

import ClickOutHandler from "react-clickout-handler";
import { IndentCreateDivisionSelect } from "../../../../../Reusable/IndentCreateDivisionSelect";
import MyInput from "../../../../../Reusable/MyInput";
import { ItemByDivisionSelect } from "../../../../../Reusable/ItemByDivisionSelect";
import { BrandByItemSelect } from "../../../../../Reusable/BrandByItemSelect";
import { IndentUnitSelect } from "../../../../../Reusable/IndentUnitSelect";
import { useNavigate } from "react-router-dom";
import { DirectPartySelect } from "../DirectPartySelect";
import { DirectPOCreateDivisionSelect } from "../DirectPOCreateDivisionSelect";
import { DirectPOSeveritySelect } from "../DirectPOSeveritySelect";
import { DirectPOItemByDivisionSelect } from "../DirectPOItemByDivisionSelect";
import { DirectPOBrandByItemSelect } from "../DirectPOBrandByItemSelect";
import { DirectPOUnitSelect } from "../DirectPOUnitSelect";
import DirectCreatePageForm from "../DirectCreatePageForm";
import { UpdDirectPartySelect } from "./UpdDirectPartySelect";
import UpdDirectCreatePageForm from "./UpdDirectCreatePageForm";
import { UpdDirectPOSeveritySelect } from "./UpdDirectPOSeveritySelect";

export default function DirectUpdate() {
  const {
    darkTheme,
    loginData,
    indentAddItemLoading,
    setIndentCreateItemId4Upd,
    setDirectPOUpdateDataItems,
    directPOUpdateDataItems,
    directPOUpdateData,
    setDirectPOUpdateData,
  } = useContext(UserContext);

  useEffect(() => {
    if (directPOUpdateData) {
      setUnsavedIndentItem(directPOUpdateData.items);

      // setSeverity(indentUpdateData.severity || "");

      setDivision(directPOUpdateData.division || "");
      setSeverity(directPOUpdateData.severity || "");
      setDate(directPOUpdateData.date || "");
      setRemark(directPOUpdateData.remarks || "");
      setIndentDocCode(directPOUpdateData.code || "");
      // setPOPartySelect(directPOUpdateData.party_id || "")
      setMyCachePartyId(directPOUpdateData.party_id || "")
    }
  }, [directPOUpdateData.division]);

  const navigate = useNavigate();

  const [division, setDivision] = useState("");
  const [poPartySelect, setPOPartySelect] = useState("");
  const [date, setDate] = useState("");
  const [severity, setSeverity] = useState("Normal");
  const [remark, setRemark] = useState("");
  const [indentDocCode, setIndentDocCode] = useState("");

  const [item, setItem] = useState("");
  const [brand, setBrand] = useState("");
  const [unit, setUnit] = useState("");
  const [qty, setQty] = useState(0);
  const [unitAmount, setUnitAmount] = useState(0);
  const [finalAmount, setFinalAmount] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [netAmount, setNetAmount] = useState(0);

  const [links, setLinks] = useState([]);
  const [firstPage, setFirstPage] = useState([]);
  const [totalNo, setTotalNo] = useState(0);
  const [from, setFrom] = useState(0);
  const [to, setTo] = useState(0);
  const [getId, setGetId] = useState(0);
  const [spinner, setSpinner] = useState(true);

  const [addMoreToggle, setAddMoreToggle] = useState(false);
  const [changingSelect, setChangingSelect] = useState(false);

  const [submitAction, setSubmitAction] = useState("submit");
  // disabled action
  const [submitDisable, setSubmitDisable] = useState(false);
  const [updateDisable, setUpdateDisable] = useState(false);
  const [itemSubmitDisable, setItemSubmitDisable] = useState(false);
  const [editDisable, setEditDisable] = useState(false);

  const [unsavedIndentItem, setUnsavedIndentItem] = useState([]);
  const [allIndentItem, setAllIndentItem] = useState([]);
  const [cacheItemId, setCacheItemId] = useState("");
  const [myCacheDivision, setMyCacheDivision] = useState("");
  const [myCachePartyId, setMyCachePartyId] = useState("");

  function directPOSelectedUpdData() {
    setSpinner(true);
    fetch(`${BaseURL}/purchase/po/getpo/${directPOUpdateData.id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    })
      .then((res) => res.json())
      .then((selectedRecord) => {
        if (selectedRecord.status) {
          // setChangingSelect(true);
          // setAddMoreToggle(true);
          // setSubmitAction("update");
          // setDivision(selectedRecord.data.division || "");
          // setItem(selectedRecord.data.item_name || "");
          // setBrand(selectedRecord.data.brand || "");
          // setUnit(selectedRecord.data.unit || "");
          // setQty(selectedRecord.data.qty || "");

          setSpinner(false);
          setDirectPOUpdateData(selectedRecord.data || {});
          setDirectPOUpdateDataItems(selectedRecord.data.items || []);
          // setDirectPOUpdateDataItems(selectedRecord.data.pass_items || []);
        }
        if (selectedRecord.status === false) {
          setSpinner(false);
        }
      });
    // setChangingSelect(false);
  }

  // TODAY CURRENT DATE DEFAULT SET

  // useEffect(() => {
  //   const today = new Date();
  //   const formattedDate = today.toISOString().split("T")[0];
  //   setDate(formattedDate);
  //   // if(date) return postCacheItemDate();
  // setCacheTypeFun();
  //   getUnsavedItemList();
  // }, []);

  // useEffect(()=>{
  //   postCacheItemDate();
  // }, [date])

  // useEffect(() => {
  //   setCacheTypeFun();
  // }, []);

  // TYPE= "Direct" SET PO CACHE
  // async function setCacheTypeFun() {
  //   const selectedData = { type: "Direct" };
  //   const response = await fetch(`${BaseURL}/purchase/po/setcache`, {
  //     method: "POST",
  //     headers: {
  //       Accept: "application/json",
  //       Authorization: `Bearer ${loginData.token}`,
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify(selectedData),
  //   });
  //   const data = await response.json();
  // }
  // // OnBlur DATE
  // async function postCacheItemDate() {
  //   const selectedData = { date: date };
  //   const response = await fetch(`${BaseURL}/purchase/po/setcache`, {
  //     method: "POST",
  //     headers: {
  //       Accept: "application/json",
  //       Authorization: `Bearer ${loginData.token}`,
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify(selectedData),
  //   });
  //   const data = await response.json();
  // }
  // // OnBlur REMARK
  // async function postCacheItemRemark() {
  //   const selectedData = { remarks: remark };
  //   const response = await fetch(`${BaseURL}/purchase/po/setcache`, {
  //     method: "POST",
  //     headers: {
  //       Accept: "application/json",
  //       Authorization: `Bearer ${loginData.token}`,
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify(selectedData),
  //   });
  //   const data = await response.json();
  // }

  // async function getUnsavedItemList() {
  //   const res = await fetch(`${BaseURL}/purchase/po/getcache`, {
  //     method: "GET",
  //     headers: {
  //       Accept: "application/json",
  //       Authorization: `Bearer ${loginData.token}`,
  //     },
  //   })
  //     .then((resdata) => resdata.json())
  //     .then((createRes) => {
  //       if (createRes.status) {
  //         // const cacheItems = createRes.data.items || [];
  //         const cacheItems =
  //           createRes.data !== null ? createRes.data.items : [];
  //         // const reverseCacheItems = cacheItems.reverse();
  //         // setUnsavedIndentItem(createRes.data.items || []);
  //         setUnsavedIndentItem(cacheItems);

  //         // const mygetdivision = createRes.data?.items[0];
  //         // const cacheDivision = mygetdivision.division;
  //         // setMyCacheDivision(cacheDivision || "");

  //         // const mygetdivision =
  //         //   createRes.data !== null ? createRes.data?.items[0] : {};
  //         // const cacheDivision = mygetdivision?.division || "";
  //         // setMyCacheDivision(cacheDivision || "");

  //         const myCacheDiv = createRes?.data?.division;
  //         const myCacheDate = createRes?.data?.date;
  //         const myCacheRemark = createRes?.data?.remarks;
  //         const myCachePId = createRes?.data?.party_id;
  //         setMyCacheDivision(myCacheDiv || "");
  //         setMyCachePartyId(myCachePId || "");
  //         setDate(myCacheDate || "");
  //         setRemark(myCacheRemark || "");

  //         setSpinner(false);
  //       }
  //     });
  // }

  // async function getAllIndentCreated() {
  //   const res = await fetch(`${BaseURL}/purchase/indent/getall`, {
  //     method: "GET",
  //     headers: {
  //       Accept: "application/json",
  //       Authorization: `Bearer ${loginData.token}`,
  //     },
  //   })
  //     .then((resdata) => resdata.json())
  //     .then((createRes) => {
  //       if (createRes.status) {
  //         setAllIndentItem(createRes.data);
  //         setSpinner(false);
  //       }
  //     });
  // }

  useEffect(() => {
    // getAllIndentCreated();
    // getUnsavedItemList();
  }, []);

  // ADD INDENT ITEM
  async function addIndentItem(e) {
    e.preventDefault();
    // const formData = new FormData();
    // formData.append("item_id", item.value || "");
    // formData.append("brand_id", brand.value || "");
    // formData.append("unit_id", unit.value || "");
    // formData.append("qty", qty || "");

    const unitRateAfterDiscount = parseFloat(netAmount) / parseFloat(qty);
    // console.log("unitRate a|fater discount", unitRateAfterDiscount.toFixed(2))

    if (division !== "") {
      setItemSubmitDisable(true);
      const formData = {
        item_id: item.value || "",
        brand_id: brand.brand_id || "",
        unit_id: unit.value || "",
        qty: qty || 0,
        party_id: poPartySelect.value || "",
        unit_rate: unitAmount || 0,
        amount: finalAmount || 0,
        discount: discount || 0,
        unit_rate_after_discount: unitRateAfterDiscount.toFixed(2) || 0,
        final_amount: netAmount || 0,
      };

      const res = await fetch(`${BaseURL}/purchase/po/adddirectpoitem/${directPOUpdateData.id}`, {
        method: "PATCH",
        body: JSON.stringify(formData),
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${loginData.token}`,
          "Content-Type": "application/json",
        },
      })
        .then((resdata) => resdata.json())
        .then((createRes) => {
          if (createRes.status) {
            setAddMoreToggle(false);
            // getUnsavedItemList();
            directPOSelectedUpdData();
            setItem("");
            setBrand("");
            setUnit("");
            setQty(0);

            setUnitAmount(0);
            setDiscount(0);
            setNetAmount(0);
            setFinalAmount(0);
            toast.success("Added on lists");
            setItemSubmitDisable(false);
          }
          if (createRes.status === false) {
            setItemSubmitDisable(false);
          }
          if (createRes?.error?.message.item_id) {
            toast.error(createRes.error.message.item_id);
          } else if (createRes?.error?.message.brand_id) {
            toast.error(createRes.error.message.brand_id);
          } else if (createRes?.error?.message.unit) {
            toast.error(createRes.error.message.unit);
          } else if (createRes?.error?.message.qty) {
            toast.error(createRes.error.message.qty);
          } else if (createRes?.error?.message.discount) {
            toast.error(createRes.error.message.discount);
          }
        });
    } else {
      toast.error("First Select Division.!");
      setItemSubmitDisable(false);
    }
  }

  // create
  // const itemId = unsavedIndentItem.map((item, index) => item.id);
  async function createDivision(e) {
    e.preventDefault();
    if (directPOUpdateDataItems.length <= 0) {
      toast.error("Please add items before submit.");
      return;
    }
    setSubmitDisable(true);
    const formData = {
      type: "Direct",
      party_id: poPartySelect.value || "",
      date: date || "",
      severity: severity.value || directPOUpdateData.severity,
      remarks: remark,
      division: directPOUpdateData.division,
    };

    const res = await fetch(`${BaseURL}/purchase/po/updatedirectpo/${directPOUpdateData.id}`, {
      method: "PATCH",
      body: JSON.stringify(formData),
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        "Content-Type": "application/json",
      },
    })
      .then((resdata) => resdata.json())
      .then((createRes) => {
        if (createRes.status) {
          // getUnsavedItemList();
          directPOSelectedUpdData();
          toast.success("Success");
          setDivision("");
          setItem("");
          setBrand("");
          setUnit("");

          setDate("");
          setSeverity("");
          setRemark("");

          setQty(0);

          setUnitAmount(0);
          setDiscount(0);
          setNetAmount(0);
          setFinalAmount(0);

          navigate("/purchase/pending-po-view");
          setSubmitDisable(false);
        }
        if (createRes.status === false) {
          setSubmitDisable(false);
        }
        if (createRes?.error?.message.date) {
          toast.error(createRes.error.message.date);
        } else if (createRes?.error?.message.severity) {
          toast.error(createRes.error.message.severity);
        }
      });
  }

  // Listing record
  function firstPageList(url = `${BaseURL}/states?page=1`) {
    setSpinner(true);
    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    })
      .then((res) => res.json())
      .then((li) => {
        if (li?.status) {
          const revData = li.data.data.reverse();
          setFirstPage(revData);
          setTotalNo(li.data.total);
          setFrom(li.data.from);
          setTo(li.data.to);
          setLinks(li.data.links);
          setSpinner(false);
        }
      });
  }

  function editBtn(editData) {
    setEditDisable(true);
   
    // console.log("iiitemse edit data", editData)
          setChangingSelect(true);
          setAddMoreToggle(true);
          setSubmitAction("update");

          setDivision(editData.division || "");
          setItem(editData.item_name || "");
          setBrand(editData.brand || "");
          setUnit(editData.unit || "");
          setQty(editData.qty || 0);
          setUnitAmount(editData.unit_rate || 0);
          setFinalAmount(editData.amount || 0);
          setNetAmount(editData.final_amount || 0);
          setDiscount(editData.discount || 0);
          setEditDisable(false);


    // setEditDisable(true);
    // fetch(`${BaseURL}/purchase/po/getcacheitem/${id}`, {
    //   method: "GET",
    //   headers: {
    //     Accept: "application/json",
    //     Authorization: `Bearer ${loginData.token}`,
    //   },
    // })
    //   .then((res) => res.json())
    //   .then((selectedRecord) => {
    //     if (selectedRecord.status) {
    //       setChangingSelect(true);
    //       setAddMoreToggle(true);
    //       setSubmitAction("update");

    //       setDivision(selectedRecord.data.division || "");
    //       setItem(selectedRecord.data.item_name || "");
    //       setBrand(selectedRecord.data.brand || "");
    //       setUnit(selectedRecord.data.unit || "");
    //       setQty(selectedRecord.data.qty || 0);
    //       setUnitAmount(selectedRecord.data.unit_rate || 0);
    //       setFinalAmount(selectedRecord.data.amount || 0);
    //       setNetAmount(selectedRecord.data.final_amount || 0);
    //       setDiscount(selectedRecord.data.discount || 0);
    //       setEditDisable(false);
    //     }
    //     if (selectedRecord.status === false) {
    //       setEditDisable(false);
    //     }
    //   });
    // setChangingSelect(false);
  }
  // UPDATE A RECORD
  async function updateIndentItem(e, id) {
    e.preventDefault();
    setUpdateDisable(true);
    if (division !== "") {
      const unitRateAfterDiscount = parseFloat(netAmount) / parseFloat(qty);

      const formData = {
        type: "Direct",
        item_id: item.value || "",
        brand_id: brand.brand_id || "",
        unit_id: unit.value || "",
        qty: qty || "",
        party_id: poPartySelect.value || "",
        unit_rate: unitAmount || "",
        amount: finalAmount || "",
        discount: discount || "",
        unit_rate_after_discount: unitRateAfterDiscount.toFixed(2) || "",
        final_amount: netAmount || "",
      };
      // console.log("formdata upd direct po item", formData)
      const updRes = await fetch(
        `${BaseURL}/purchase/po/updatedirectpoitem/${id}`,
        {
          method: "PATCH",
          body: JSON.stringify(formData),
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${loginData.token}`,
            "Content-Type": "application/json",
          },
          // body: JSON.stringify({name: divisionName}),
        }
      )
        .then((res) => res.json())
        .then((upd) => {
          if (upd.status) {
            // getUnsavedItemList();
            directPOSelectedUpdData();

            setGetId(0);
            setItem("");
            setBrand("");
            setUnit("");
            setQty(0);

            setUnitAmount(0);
            setDiscount(0);
            setNetAmount(0);
            setFinalAmount(0);

            setSubmitAction("submit");
            setAddMoreToggle(false);
            toast.success("Updated");
            setUpdateDisable(false);
          }
          if (upd.status === false) {
            setUpdateDisable(false);
          }
          if (upd?.error?.message.item_id) {
            toast.error(upd.error.message.item_id);
          } else if (upd?.error?.message.brand) {
            toast.error(upd.error.message.brand);
          } else if (upd?.error?.message.unit) {
            toast.error(upd.error.message.unit);
          } else if (upd?.error?.message.qty) {
            toast.error(upd.error.message.qty);
          } else if (upd?.error?.message) {
            toast.error(upd.error.message);
          }
        });
    }
  }

  function cancelUpdate() {
    setIndentCreateItemId4Upd(0);
    setGetId(0);
    setSubmitAction("submit");
    setItem("");
    setBrand("");
    setUnit("");
    setQty(0);

    setUnitAmount(0);
    setDiscount(0);
    setNetAmount(0);
    setFinalAmount(0);

    setSubmitDisable(false);
    setEditDisable(false);
    setUpdateDisable(false);
    setItemSubmitDisable(false);

    // setDivision("");
    // setDate("");
    // setSeverity("");
    // setRemark("");
  }

  function cancelPopup() {
    setIndentCreateItemId4Upd(0);
    setGetId(0);
    setAddMoreToggle(false);
    setItem("");
    setBrand("");
    setUnit("");
    setQty(0);

    setUnitAmount(0);
    setDiscount(0);
    setNetAmount(0);
    setFinalAmount(0);

    setSubmitDisable(false);
    setEditDisable(false);
    setUpdateDisable(false);
    setItemSubmitDisable(false);

    // setDivision("");
    // setDate("");
    // setSeverity("");
    // setRemark("");
    setSubmitAction("submit");
  }

  function popupCreateIndentOnClickOut() {
    setIndentCreateItemId4Upd(0);
    setGetId(0);
    setAddMoreToggle(false);
    setItem("");
    setBrand("");
    setUnit("");
    setQty("");
    setSubmitAction("submit");
    // setDivision("");
  }

  useEffect(() => {
    // const totalFinalAmount= (unitAmount && qty) ? (parseFloat(unitAmount) * parseFloat(qty)) : 0;
    const totalFinalAmount = parseFloat(unitAmount) * parseFloat(qty);
    const TwoDecFixed = totalFinalAmount.toFixed(2);
    // setFinalAmount(parseFloat(TwoDecFixed))
    setFinalAmount(TwoDecFixed);
  }, [unitAmount, qty]);

  useEffect(() => {
    const totalFinalAmount = parseFloat(unitAmount) * parseFloat(qty);
    const TwoDecFixed = totalFinalAmount.toFixed(2);

    const totalNetAmount = TwoDecFixed - parseFloat(discount);
    const finalNetTwoDecFixed = totalNetAmount.toFixed(2);
    setNetAmount(finalNetTwoDecFixed);
  }, [discount, qty, unitAmount]);

  return (
    <div
      className={`p-2 pb-8 rounded-xl text-sm ${
        darkTheme ? "bg-slate-600" : "bg-slate-100"
      }`}
    >
      <div>
        <div>
          <div
            className={`font-[600] text-sm uppercase text-center my-2 border-b bg-[#b4a996] py-1 mb-4 rounded-tr-lg rounded-tl-lg ${
              darkTheme ? "border-b-slate-700" : "border-b-slate-200"
            }`}
          >
           Update Direct PO
          </div>
          <div className="mb-2">
            <div className="grid grid-cols-1">
              {/* LEFT PART  */}
              <div className="px-2 w-full mb-2">
                <form>
                  <div className="grid grid-cols-2 gap-x-2 md:grid-cols-4 lg:grid-cols-5">
                    {/* <div className="mb-2 w-full">
                      <label>
                        Division{" "}
                        <span className="text-red-500 font-bold">*</span>
                      </label>
                      <DirectPOCreateDivisionSelect
                        selectedOption={division}
                        setSelectedOption={setDivision}
                        changingSelect={changingSelect}
                        setEmpty={setItem}
                        addMoreToggle={addMoreToggle}
                        unsavedIndentItem={unsavedIndentItem}
                        setUnsavedIndentItem={setUnsavedIndentItem}
                        myCacheDivision={myCacheDivision}
                        getUnsavedItemList={getUnsavedItemList}
                        setBrand={setBrand}
                        setItem={setItem}
                        setUnit={setUnit}
                        setQty={setQty}
                      />
                    </div> */}

                    <div className="mb-2 w-full">
                      <label className="!font-bold">Indent No.</label>
                      <textarea
                        rows={2}
                        type="text"
                        // disabled={true}
                        readOnly
                        className={`border uppercase rounded-lg py-[8px] px-3 outline-none border-gray-500 text-gray-500 font-bold bg-[#ffff] w-full`}
                        value={indentDocCode}
                        onChange={(e) => setIndentDocCode(e.target.value)}
                      />
                    </div>

                    <div className="mb-2 w-full">
                      <label>
                        Division : {/* {indentUpdateData.division}{" "} */}
                        {/* <small className="text-red-500">
                          (You can&#39;t change)
                        </small> */}
                      </label>
                      <input
                        type="text"
                        // disabled={true}
                        readOnly
                        className={`border block uppercase rounded-lg py-[8px] px-3 outline-none border-gray-500 text-gray-500 font-bold bg-[#ffff] w-full`}
                        value={directPOUpdateData.division}
                      />
                    </div>

                    <div className="mb-2 w-full">
                      <label>
                        Party <span className="text-red-500 font-bold">*</span>
                      </label>
                      <UpdDirectPartySelect
                        selectedOption={poPartySelect}
                        setSelectedOption={setPOPartySelect}
                        changingSelect={changingSelect}
                        setChangingSelect={setChangingSelect}
                        // setEmpty={setItem}
                        // addMoreToggle={addMoreToggle}
                        unsavedIndentItem={unsavedIndentItem}
                        setUnsavedIndentItem={setUnsavedIndentItem}
                        // getUnsavedItemList={getUnsavedItemList}
                        myCachePartyId={myCachePartyId}
                        setBrand={setBrand}
                        setItem={setItem}
                        setUnit={setUnit}
                        setQty={setQty}
                      />
                    </div>

                    <div className="mb-2 w-full">
                      <label>
                        Severity:{" "}
                        <span className="text-red-500 font-bold">*</span>{" "}
                        <span className="font-[600] text-red-800">{directPOUpdateData.severity}</span>
                      </label>
                      <UpdDirectPOSeveritySelect
                        selectedOption={severity}
                        setSelectedOption={setSeverity}
                        // setChangingSelect={setChangingSelect}
                      />
                    </div>
                    <MyTextarea
                      label="Remark"
                      type="text"
                      className="w-full"
                      value={remark}
                      onChange={(e) => setRemark(e.target.value)}
                      // onBlur={() => postCacheItemRemark()}
                    />
                    <div className="mb-2 w-full">
                      <label className="mr-2 block mb-[4px]">
                        Date <span className="text-red-500 font-bold">*</span>
                      </label>
                      <input
                        // onBlur={() => postCacheItemDate()}
                        className={`py-1.5 rounded-lg px-2 md:px-3 outline-none border ${
                          darkTheme
                            ? "bg-gray-700 border-gray-500"
                            : "bg-white border-gray-500"
                        }`}
                        value={date}
                        onChange={(e) => setDate(e.target.value)}
                        type="date"
                        name="date"
                      />
                    </div>
                  </div>
                </form>
              </div>
              {/* END LEFT PART  */}

              {/* RIGHT PART  */}
              <div className="bg-[#8CDDCD] rounded-xl p-3">
                <div className="mb-2 grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-x-2">
                  <div className="mb-2">
                    <label>
                      Item <span className="text-red-500 font-bold">*</span>{" "}
                      <span className="text-[12px]">
                        {item ? `HSNno. ${item.hsn_no}` : ""}
                      </span>
                    </label>
                    <DirectPOItemByDivisionSelect
                      divisionLabel={division && division}
                      selectedOption={item}
                      setSelectedOption={setItem}
                      setEmpty={setBrand}
                      changingSelect={changingSelect}
                      setChangingSelect={setChangingSelect}
                    />
                  </div>
                  {/* <div className="mb-2">
                    <label>
                      Item Code{" "}
                      <span className="text-red-500 font-bold">*</span>
                    </label>
                    <ItemByDivisionSelect
                      divisionLabel={division && division}
                      selectedOption={item}
                      setSelectedOption={setItem}
                      setEmpty={setBrand}
                      changingSelect={changingSelect}
                    />
                  </div> */}
                  <div className="mb-2">
                    <label>
                      Brand <span className="text-red-500 font-bold">*</span>
                    </label>
                    <DirectPOBrandByItemSelect
                      itemItemId={item && item.value}
                      selectedOption={brand}
                      setSelectedOption={setBrand}
                      changingSelect={changingSelect}
                      setChangingSelect={setChangingSelect}
                    />
                  </div>

                  <div className="mb-2">
                    <label>
                      Unit <span className="text-red-500 font-bold">*</span>
                    </label>
                    <DirectPOUnitSelect
                      selectedOption={unit}
                      setSelectedOption={setUnit}
                      unitByItem={item}
                      changingSelect={changingSelect}
                      setChangingSelect={setChangingSelect}
                    />
                  </div>
                  <MyInput
                    value={qty}
                    onChange={(e) => setQty(e.target.value)}
                    label="Quantity"
                    className="w-full"
                    mendatory="*"
                    type="number"
                  />
                  <MyInput
                    value={unitAmount}
                    onChange={(e) => setUnitAmount(e.target.value)}
                    label="Unit Amount"
                    type="number"
                    className="w-full"
                    mendatory="*"
                  />
                  <MyInput
                    value={finalAmount}
                    onChange={(e) => setFinalAmount(e.target.value)}
                    label="Final Amount"
                    type="number"
                    className="w-full"
                    mendatory="*"
                    readOnly
                  />
                  <MyInput
                    value={discount}
                    onChange={(e) => setDiscount(e.target.value)}
                    label="Discount"
                    type="number"
                    className="w-full"
                    mendatory="*"
                  />
                  <MyInput
                    value={netAmount}
                    onChange={(e) => setNetAmount(e.target.value)}
                    label="Net Amount"
                    type="number"
                    className="w-full"
                    mendatory="*"
                    readOnly
                  />
                </div>
                <div className="flex items-center justify-center gap-1">
                  {submitAction === "submit" && (
                    <Button
                      disabled={itemSubmitDisable}
                      type="submit"
                      onClick={(e) => addIndentItem(e)}
                      className="!bg-yellow-600"
                    >
                      {itemSubmitDisable ? "Wait.." : "Add Item"}
                    </Button>
                  )}
                  {submitAction !== "submit" && (
                    <Button
                      disabled={updateDisable}
                      type="submit"
                      onClick={(e) => updateIndentItem(e, getId)}
                      className="!bg-yellow-600"
                    >
                      {updateDisable ? "Wait.." : "Update Item"}
                    </Button>
                  )}
                  <Button
                    onClick={() => cancelPopup()}
                    className="!bg-gray-200 !text-black"
                  >
                    Cancel
                  </Button>
                </div>
              </div>
              {/* END RIGHT PART  */}
            </div>
          </div>

          {/* ITEM LIST FORM  */}
          <div className="w-full px-2 mb-4">
            <UpdDirectCreatePageForm
              editBtn={editBtn}
              // firstPageList={getUnsavedItemList}
              links={links}
              firstPage={directPOUpdateDataItems}
              setGetId={setGetId}
              spinner={spinner}
              totalNo={totalNo}
              from={from}
              to={to}
              addMoreToggle={addMoreToggle}
              setAddMoreToggle={setAddMoreToggle}
              directPOSelectedUpdData={directPOSelectedUpdData}
              editDisable={editDisable}
            />
          </div>

          {submitAction === "submit" && (
            <div className="flex items-center justify-center gap-x-1 mt-2">
              <Button
                type="submit"
                // disabled={submitDisable || unsavedIndentItem.length <= 0}
                disabled={submitDisable}
                onClick={(e) => createDivision(e)}
              >
                {submitDisable ? "Wait.." : "Update"}
              </Button>
              <Button type="button" onClick={() => cancelUpdate()}>
                Clear
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
